"use strict";

console.log("EXAMPLE");
